import { graphql } from "@/graphql/codegen"

graphql(`
  query GetCompanyNameById($companyId: UUID!) {
    company {
      get(input: { companyId: $companyId }) {
        ... on CompanyGetSuccess {
          company {
            name
          }
        }
      }
    }
  }
`)
